import axios from 'axios';

const API_URL = '/api/v1/custom-notification/';

const GET = 'all';

const getCustomNotifications = async () => {
	return await axios.get(`${API_URL}${GET}`);
};

const createCustomNotification = ({ customNotification, customerPhoneNumber }) => {
	return axios.post(`${API_URL}`,
		{
			customNotification,
			customerPhoneNumber,
		});
};

export {
	getCustomNotifications,
	createCustomNotification
};
